import "typeface-lato"
import "@fontsource/victor-mono/400.css"
import "@fontsource/victor-mono/400-italic.css"
import "@fontsource/victor-mono/500.css"
import "@fontsource/victor-mono/600.css"
import "@fontsource/inter"
import "@fontsource/sora"

const CODE_BLOCK_ITALIC_STYLES = `
  div.container {
    margin: 0 !important;
    padding-bottom: 0 !important;
  }

  div.container code {
    font-weight: 700;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  .token.comment,
  .token.prolog,
  .token.doctype,
  .token.cdata,
  .token.keyword,
  .token.atrule,
  .token.attr-value,
  .token.storage,
  .token.variable.language {
    font-style: italic;
  }
`

function styleCodeBlocks() {
  document.querySelectorAll("deckgo-highlight-code").forEach(el => {
    const root = el.shadowRoot
    if (!root) return

    let style = root.querySelector("[data-ayu-code-style]")
    if (!style) {
      style = document.createElement("style")
      style.setAttribute("data-ayu-code-style", "")
      root.appendChild(style)
    }
    style.textContent = CODE_BLOCK_ITALIC_STYLES
  })
}

export const onRouteUpdate = () => {
  if (typeof window === "undefined") return
  requestAnimationFrame(styleCodeBlocks)
}

export const onInitialClientRender = () => {
  if (typeof window === "undefined") return
  requestAnimationFrame(styleCodeBlocks)
}
